import React from "react";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Loader from "@amzn/meridian/loader";

/**
 * Loading fallback for lazy-loaded route components.
 *
 * Renders a centered loader within the content area while the route
 * chunk downloads. The app shell (masthead + sidebar) stays visible
 * so there's no white flash or layout jitter.
 */
export const RouteLoadingFallback: React.FC = () => (
  <Column height="100%" alignmentHorizontal="center" alignmentVertical="center" heights="fit">
    <Row width="100%" alignmentHorizontal="center" alignmentVertical="center" widths="fit">
      <Loader size="large" data-testid="route-loading-fallback" />
    </Row>
  </Column>
);
